var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7085 8.08641C19.8657 7.92927 20.1365 7.91324 20.2957 8.08697C21.2284 9.10428 21.7446 9.85754 21.9146 10.6918C22.0124 11.1717 22.0263 11.6603 21.9557 12.1354C21.7649 13.4197 20.7244 14.4602 18.6434 16.5411L16.1051 19.0795C14.0241 21.1604 12.9836 22.2009 11.6994 22.3918C11.2242 22.4624 10.7357 22.4484 10.2557 22.3506C9.4216 22.1807 8.66841 21.6646 7.65127 20.7321C7.47734 20.5726 7.49342 20.3015 7.65074 20.1442C8.52693 19.268 8.48529 17.8058 7.55776 16.8783C6.63022 15.9507 5.16802 15.9091 4.29183 16.7853C4.13451 16.9426 3.86341 16.9587 3.70395 16.7848C2.77146 15.7676 2.25536 15.0144 2.08539 14.1803C1.98759 13.7004 1.97368 13.2118 2.04429 12.7367C2.23513 11.4524 3.27561 10.4119 5.35657 8.33096L7.89492 5.7926C9.97588 3.71164 11.0164 2.67116 12.3006 2.48032C12.7758 2.40971 13.2643 2.42362 13.7443 2.52142C14.5785 2.69142 15.3318 3.20761 16.3491 4.1403C16.5228 4.29958 16.5068 4.57036 16.3496 4.7275C15.4734 5.60368 15.5151 7.06589 16.4426 7.99342C17.3701 8.92096 18.8324 8.96259 19.7085 8.08641Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15.436L9 5.43604",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsIcon);
export default __webpack_public_path__ + "static/media/bookings-icon.d7a96d0cad75b1219e65f277e603fc0d.svg";
export { ForwardRef as ReactComponent };